import { render, staticRenderFns } from "./CustomerData.vue?vue&type=template&id=6566da77&scoped=true"
import script from "./CustomerData.vue?vue&type=script&lang=js"
export * from "./CustomerData.vue?vue&type=script&lang=js"
import style0 from "./CustomerData.vue?vue&type=style&index=0&id=6566da77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6566da77",
  null
  
)

export default component.exports